import React from 'react';
import { Price } from 'b2b-apps/shop/product/components/ProductData/PriceList/Price';
import { ComponentType } from './';

const SecondaryPrices: ComponentType = ({ prices }) => {
  if (Object.keys(prices).length > 1) {
    return (
      <div className="PriceList-SecondaryPrices">
        <Price
          price={prices.userPrice.price}
          tax={prices.userPrice.tax}
          isSecondary
        />

        <Price
          price={prices.listPriceWithoutVat.price}
          tax={prices.listPriceWithoutVat.tax}
          isSecondary
        />

        <Price
          price={prices.listPrice.price}
          tax={prices.listPrice.tax}
          isSecondary
        />
      </div>
    );
  }

  return null;
};

export { SecondaryPrices };
